export default __webpack_public_path__ + "static/media/IconAuto2.fd791ba4.png";